"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDesktop = exports.isTablet = exports.isMobile = void 0;
var MOBILE = 'mobile';
var TABLET = 'tablet';
var DESKTOP = 'desktop';

var getDeviceType = function getDeviceType() {
  var _navigator = navigator,
      userAgent = _navigator.userAgent;

  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
    return TABLET;
  }

  if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent)) {
    return MOBILE;
  }

  return DESKTOP;
};

var isMobile = function isMobile() {
  return getDeviceType() === MOBILE;
};

exports.isMobile = isMobile;

var isTablet = function isTablet() {
  return getDeviceType() === TABLET;
};

exports.isTablet = isTablet;

var isDesktop = function isDesktop() {
  return getDeviceType() === DESKTOP;
};

exports.isDesktop = isDesktop;